import {Button, ButtonProps, TextField, TextFieldProps} from "@mui/material";
import React, {ReactElement} from "react";
import {colorHighlightAlt} from "../shared/colors";
import {DatePickerProps, MobileDatePicker} from "@mui/x-date-pickers";
import {PD_XLG} from "../shared/dimens";

export function CheckinButton(props: ButtonProps & {}): ReactElement {
  return <Button
    {...props}
    style={{
      height: 60,
      padding: `0px ${PD_XLG}px`,
      fontSize: "100%",
      borderRadius: 60,
      ...props.style
    }}/>
}

export function CheckinLargeButton(props: ButtonProps & {}): ReactElement {
  return <Button
    variant="contained"
    {...props}
    style={{
      height: 120,
      borderRadius: 60,
      paddingLeft: 72,
      paddingRight: 72,
      fontSize: "125%",
      ...props.style
    }}/>
}

export function CheckinLargeTextField(props: TextFieldProps & {}): ReactElement {
  return <TextField
    {...props}
    size={"small"}
    style={{
      border: "4px solid " + colorHighlightAlt, ...props.style
    }}
    InputProps={{
      ...props.InputProps,
      style: {
        height: 64,
        fontSize: "150%",
        ...props.InputProps?.style,
      },
    }}
  />
}

export function CheckinLargeDatePicker(props: DatePickerProps<any> & {}): ReactElement {
  return <MobileDatePicker
    {...props}
    openTo={"year"}
    slotProps={{
      textField: {
        sx: {
          "& .MuiInputBase-input": {
            height: 32,
            fontSize: "240%",
          },
          border: "4px solid " + colorHighlightAlt,
        }
      }
    }}
  />
}